import './dropDownList.css';

/**
 * Drop Down List View
 * @description Actions on selection list to use with any other view, via the triggeredAction
 */
export const DropDownList = Backbone.View.extend({
  initialize: function (options) {
    this.setElement(options.containerSelector);
    this.itemSelector = options.itemSelector;
    this.$label = $(options.labelSelector);
    this.$closeButton = $(options.labelSelector);
    this.triggeredAction = options.triggeredAction;
    this.datasList = options.datas;
    this.initSelector();
  },

  initSelector: function () {
    $(this.itemSelector).off('click.dropdown').on('click.dropdown', event => {
      const $item = $(event.currentTarget);
      const label = $item.data('label').toLowerCase() === 'distance' ? $item.html() : $item.data('label');
      let previousLabel = '';

      $(this.itemSelector).removeClass('selected');
      $item.addClass('selected');

      // mise à jour du label apparent
      if (!$.isEmptyObject(this.$label)) {
        previousLabel = this.$label.html();
        this.$label.html(label);
      }

      // Auto close
      this.$closeButton.click();

      const oData = {'label': label, 'previousLabel': previousLabel};
      $.each(this.datasList, (key, value) => {
        oData[value] = $item.data(value);
      });

      dispatcher.trigger(this.triggeredAction, oData);
    });

    $(document).off('click.dropdownBodyClick').on('click.dropdownBodyClick', () => {
      $('.dropDownList-label.toltip').removeClass('active');
    });
  }
});